// 今は使わないことにしている

import { FC } from "react";
import { IPosNeg } from "../../../../../../api-schema/reviews";
import { IEvaluateCategoryKeys } from "../../../../const";
import categoryConverter from "../../../../utils/categoryConverter";

type TagsProps = {
  categories: {
    [key in IEvaluateCategoryKeys]: IPosNeg | "neu" | null;
  };
};
const CategoryTags: FC<TagsProps> = ({ categories }) => {
  const positiveKeys = Object.keys(categories).filter(
    (key) => categories[key as IEvaluateCategoryKeys] === "pos"
  ) as IEvaluateCategoryKeys[];
  const negativeKeys = Object.keys(categories).filter(
    (key) => categories[key as IEvaluateCategoryKeys] === "neg"
  ) as IEvaluateCategoryKeys[];
  const neutralKeys = Object.keys(categories).filter(
    (key) => categories[key as IEvaluateCategoryKeys] === "neu"
  ) as IEvaluateCategoryKeys[];

  const positiveTags = positiveKeys
    .map((keyEn) => categoryConverter(keyEn))
    .map((keyJp) => {
      return (
        <div key={keyJp} className="tag is-success">
          {keyJp}
        </div>
      );
    });

  const negativeTags = negativeKeys
    .map((keyEn) => categoryConverter(keyEn))
    .map((keyJp) => {
      return (
        <div key={keyJp} className="tag is-danger">
          {keyJp}
        </div>
      );
    });
  const neutralTags = neutralKeys
    .map((keyEn) => categoryConverter(keyEn))
    .map((keyJp) => {
      return (
        <div key={keyJp} className="tag">
          {keyJp}
        </div>
      );
    });

  return (
    <div className="tags">
      {positiveTags}
      {negativeTags}
      {neutralTags}
    </div>
  );
};

export default CategoryTags;
